// extracted by mini-css-extract-plugin
export default {"Selector":"Selector___dZxv5"};